module.exports = __webpack_public_path__ + "c3bc5a49f582f5ab62b077783625e5b1.png";